export default {
    form1: {
        pk: '',
        bingli: 0,
        shiforfufa: 0,
        gengxin: 0,
        xingming: '',
        shenfenzheng: '',
        nianling: '',
        xingbie: '',
        minzu: '汉族',
        huji: [],
        zhiye: '',
        hunyin: '',
        dianhua: '',
        lianxifangshi: '',
        lianxidizhi: '',
        uuid: '',
        jibenxinxi_baogaotupian:[],
        hin:"",
        opn:""
    },
    form2: {
        jiuzhenriqi: '',
        jiuzhennianling: '',
        jiuzhenyiyuan: '',
        shouzhiyiyuan: '',
        shouzhishijian: '',
        xuechanggui_wbc: '',
        xuechanggui_rbc: '',
        xuechanggui_hb: '',
        xuechanggui_plt: '',
        gongnengzhuangtai_ecog: '',
        xibaoxingtai_gusuiyuanxibao: '',
        xibaoxingtai_gusuiyuanshixibao: '',
        xibaoxingtai_waizhouxueyuanshixibao: '',
        xibaoxingtai_guisuibaogaotupian: [],
        chuningxuezhibiao_aptt: '',
        chuningxuezhibiao_pt: '',
        chuningxuezhibiao_tt: '',
        chuningxuezhibiao_fib: '',
        chuningxuezhibiao_fdp: '',
        chuningxuezhibiao_d_dimmer: '',
        chuningxuezhibiao_dimmer: '',
        gangongneng_alt: '',
        gangongneng_ast: '',
        gangongneng_akp: '',
        gangongneng_ggt: '',
        gangongneng_ldh: '',
        gangongneng_dbil: '',
        gangongneng_alb: '',
        gangongneng_tbil: '',
        shengongneng_alt: '',
        shengongneng_bun: '',
        shengongneng_cr: '',
        shengongneng_ua: '',
        dianjiezhi_na: '',
        dianjiezhi_k: '',
        dianjiezhi_cl: '',
        dianjiezhi_ca: '',
        alfenlei: '',
        zhenduanfenxing: []
    },
    form3: {
        weizuojiancha: false,
        aml: [],
        aml_qita: '',
        all: [],
        all_qita: '',
        baogaotupian: []
    },
    form4: {
        // aml
        negative: false,
        weizuojiancha: false,
        aml_tsl_erg: '',
        aml_runx1_runxt1: '',
        aml_cbfb_myh11: '',
        aml_bcr_abl1: '',
        aml_pml_rara: '',
        aml_pml_rara_value: [],
        aml_bcr_abl1_value: [],
        aml_nup98: '',
        aml_nup98_content: '',
        aml_nup98_conntent: '',
        aml_mkt2a: '',
        aml_kmt2a: '',
        aml_kmt2a_content: '',
        aml_rara: '',
        aml_rara_content: '',
        aml_tls_erg: '',
        aml_dek_nup214: '',
        // mutation
        aml_npm1: '',
        aml_dnmt3a: '',
        aml_cebpa: '',
        aml_c_kit: '',
        aml_cebpa2: '',
        aml_nras: '',
        aml_flt3_itd: '',
        aml_asxl1: '',
        aml_flt3_itd_low: '',
        aml_flt3_itd_high: '',
        aml_runx1: '',
        aml_flt3_tkd: '',
        aml_idh1: '',
        aml_mll_ptd: '',
        aml_idh2: '',
        aml_tp53: '',
        aml_tet2: '',
        // ball
        ball_bcr_abl1: '',
        ball_ph_like: '',
        ball_ph_like_content: '',
        ball_kmt2a: '',
        ball_mkt2a_content: '',
        ball_etv6_runx1: '',
        ball_tcf3_pbx1: '',
        ball_tcf34_hlf: '',
        ball_pax5: '',
        ball_pax5_content: '',
        ball_crlf2: '',
        ball_crlf2_content: '',
        ball_znf384: '',
        ball_znf384_content: '',
        ball_dux4: '',
        ball_dux4_content: '',
        ball_mef2d: '',
        ball_mef2d_content: '',
        ball_nutm1: '',
        ball_nutm1_content: '',
        ball_igh: '',
        ball_igh_content: '',
        // ball mutation
        ball_ikzf1_ik6: '',
        ball_ikzf1_n159y: '',
        ball_pax5_p80r: '',
        ball_zeb2_h1038r: '',
        // tall
        tall_tal1: '',
        tall_tal1_high: '',
        tall_tal1_content: '',
        tall_tal2: '',
        tall_tal2_high: '',
        tall_tal2_content: '',
        tall_tlx1: '',
        tall_tlx1_high: '',
        tall_tlx1_content: '',
        tall_tlx3: '',
        tall_tlx3_high: '',
        tall_tlx3_content: '',
        tall_hoxa10: '',
        tall_hoxa_high: '',
        tall_hoxa10_content: '',
        tall_spi1: '',
        tall_spi1_high: '',
        tall_spi1_content: '',
        tall_lmo1: '',
        tall_lmo1_high: '',
        tall_lmo1_content: '',
        tall_lmo2: '',
        tall_lmo2_high: '',
        tall_lmo2_content: '',
        tall_nkx21: '',
        tall_nkx21_high: '',
        tall_nkx21_content: '',
        tall_set_nup214: '',
        tall_kmt2a: '',
        tall_lyl1_high: '',
        tall_mef2c_high: '',
        tall_kmt2a_content: '',
        tall_mllt10: '',
        tall_mllt10_content: '',
        tall_abl1: '',
        tall_abl1_content: '',
        tall_myb: '',
        tall_myb_content: '',
        tall_tcr: '',
        tall_tcr_content: '',
        tall_notch1: '',
        tall_fbxw7: '',
        tall_phf6: '',
        tall_jak1: '',
        tall_jak3: '',
        tall_pten: '',
        tall_nras: '',
        tall_kras: '',
        tall_usp7: '',
        tall_gata3: '',
        tall_rpl10: '',
        //
        qita: false,
        qita_content: '',
        baogaotupian: [],
        aml_npm1_point: '',
        aml_cebpa_point: '',
        aml_cebpa2_point: '',
        aml_flt3_tkd_point: '',
        aml_mll_ptd_point: '',
        aml_tp53_point: '',
        aml_dnmt3a_point: '',
        aml_c_kit_point: '',
        aml_nras_point: '',
        aml_asxl1_point: '',
        aml_idh1_point: '',
        aml_idh2_point: '',
        aml_tet2_point: '',
        aml_runx1_point: '',
        tall_notch1_point: '',
        tall_fbxw7_point: '',
        tall_phf6_point: '',
        tall_jak1_point: '',
        tall_jak3_point: '',
        tall_pten_point: '',
        tall_nras_point: '',
        tall_kras_point: '',
        tall_usp7_point: '',
        tall_gata3_point: '',
        tall_rpl10_point: '',
    },
    form5: {
        weizuojiancha: false,
        cd10: '',
        select_cd10: '',
        cd19: '',
        select_cd19: '',
        cd20: '',
        select_cd20: '',
        cd22: '',
        select_cd22: '',
        cd79a: '',
        select_cd79a: '',
        cyu: '',
        select_cyu: '',
        cd1a: '',
        select_cd1a: '',
        cd2: '',
        select_cd2: '',
        ccd3: '',
        select_cd3: '',
        cd4: '',
        select_cd4: '',
        cd5: '',
        select_cd5: '',
        cd7: '',
        select_cd7: '',
        cd8: '',
        select_cd8: '',
        cd56: '',
        select_cd56: '',
        tdt: '',
        select_tdt: '',
        cd13: '',
        select_cd13: '',
        cd14: '',
        select_cd14: '',
        cd15: '',
        select_cd15: '',
        cd33: '',
        select_cd33: '',
        cd34: '',
        select_cd34: '',
        cd117: '',
        select_cd117: '',
        cd11b: '',
        select_cd11b: '',
        hla_dr: '',
        select_hla_dr: '',
        mpo: '',
        select_mpo: '',
        qita: '',
        laip: '',
        mrd: '',
        select_mrd: '',
        gcd64: '',
        select_gcd64: '',
        bcd34: '',
        select_bcd34: '',
        btdt: '',
        select_btdt: '',
        baogaotupian: [],
    },
    form6: {
        aplzhiliaofangan: '',
        aml_m3: '',
        aml_m: '',
        newzhiliaofangan: '',
        allo_sct_mrd: '',
        biaozhunzhiliaofangan: '',
        suifang_shijian: '',
        suifang_status: '',
        zhiliaofangan: {
            "one": "",
            "two": "",
            "three": "",
            "four": "",
            "five": "",
            "six": "",
            "seven": '',
            "other": '',
            "eight": '',
        },
        weinaikelafangan: '',
        weinaikelaqita: '',
        dnr: '',
        dnr_ara_c: '',
        ida: '',
        ida_ara_c: '',
        hht: '',
        hht_ara_c: '',
        acla: '',
        tki_yaowu: '',
        siwangshijian_accurate: "1",
        tki_yaowu_yongliang: '',
        xinyaolinchuangshiyan: '',
        qita: '',
        shifou_huodecr: '',
        shifou_auto_sct: '',
        shifou_allo_sct: '',
        allo_sct_leixing: '',
        shifou_fufa: '',
        shifou_siwang: '',
        huode_cr_shijian: '',
        huode_nr_shijian: '',
        auto_sct_shijian: '',
        allo_sct_shijian: '',
        shoucifufashijian: '',
        siwangshijian: '',
        siwangyuanyin: [],
        siwangyuanyin_qita: '',
        timeline: [],
        fangan_shijian: '',
        zhenduanfenxing: [],
        fangqi_shijian: '',
        fangqi_shijian_type: '',
        shifang_shijian: '',
        suifang_beiju: ''
    },
    form7: {
        shifangshijian: '',
        siwangshijian: '',
        zhiliaozhuangtai: '',
        shengcunzhuangtai: '存活',
        siwangyuanyin: [],
        siwangyuanyin_qita: '',
        yibaoleixing: '',
        zhiliaofeiyong: '',
        remarks: [],
        is_chufa: 1
    },
    form8: {
        weizuofusion: [],
        weizuomutation: [],
        weizuodysregulation: [],
    },
    form9: [],
    form10: {
        share_data: [],
        tags: []
    }
}
